import { useState } from 'react';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: "What documents will I receive from Asiatic after my account is opened?",
      answer: `First, you will receive a Welcome Letter by email containing your User Id and password.
Subsequently, the following documents will follow:
- Your personal details as in your application
- Details of your bank and DP accounts
- Link to download the trading software
- Exchange confirmation and the segments opted for by you
- Brokerage charges
- Link to view the Risk Disclosure Document, Policy and Procedures, Do's and Don'ts`
    },
    {
      question: "How do I activate my online trading account?",
      answer: `After your account opening process is complete, you will receive an email on your registered email id, which would contain the activation link to your account.
To activate, click on the link and enter your username and the password`
    },
    {
      question: "In the event of my Internet connection being down, can I call and place orders?",
      answer: `To place orders via telephone, call us on (91-011)-41545955/58, 23554225/6/7, 23633955, 9818038286`
    },
    {
      question: "How do I change my communication address?",
      answer: `Download the request letter from CLICK HERE and submit the same along with an attested copy of either of the following documents:
- Electricity bill
- Passport
- Latest telephone bill
- Bank passbook/Banker's verification
- Rent Agreement
- Insurance policy
- Ration card
- Voter id`,
      hasLink: true,
      linkText: "CLICK HERE",
      linkUrl: "assets/pdf/request-letter.pdf"
    },
    {
      question: "How do I change my Contact Number registered with Asiatic?",
      answer: `Download the request letter related to Change in Mobile Number from HERE, fill it out and mail them to us to enable us update the same CLICK HERE`,
      hasLink: true,
      linkText: "CLICK HERE",
      linkUrl: "assets/pdf/request-letter.pdf"
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Function to render answer with clickable links
  const renderAnswer = (item) => {
    if (!item.hasLink) {
      return <p style={{ whiteSpace: 'pre-line' }}>{item.answer}</p>;
    }

    // Split the text to insert the link
    const parts = item.answer.split(item.linkText);
    
    return (
      <p style={{ whiteSpace: 'pre-line' }}>
        {parts[0]}
        <a 
          href={item.linkUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="faq-link"
        >
          {item.linkText}
        </a>
        {parts[1]}
      </p>
    );
  };

  return (
    <div className="container">
      <div className="row faqasiatic">
        <div className="col-md-12">
          
          <div className="faq-container">
            {faqItems.map((item, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'active' : ''}`}
              >
                <div 
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <h4>{item.question}</h4>
                  <span className="faq-icon">
                    {openIndex === index ? '−' : '+'}
                  </span>
                </div>
                <div className="faq-answer">
                  {renderAnswer(item)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="clearfix"></div>
      <br />

      <style jsx>{`
        .faqasiatic {
          background: #fff;
          border-radius: 20px;
          padding: 3rem 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          margin: 2rem 0;
        }

        .faq-item {
          background: #f8f9fa;
          border-radius: 12px;
          margin-bottom: 1rem;
          border: 2px solid transparent;
          transition: all 0.3s ease;
          overflow: hidden;
        }

        .faq-item:hover {
          border-color: #007bff;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 123, 255, 0.1);
        }

        .faq-item.active {
          border-color: #007bff;
          background: #ffffff;
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.15);
        }

        .faq-question {
          padding: 1rem 2rem;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s ease;
        }

        .faq-question:hover {
          background: rgba(0, 123, 255, 0.05);
        }

        .faq-question h4 {
          margin: 0;
          color: #2c3e50;
          font-weight: 600;
          font-size: 1.1rem;
          line-height: 1.4;
          flex: 1;
          padding-right: 2rem;
        }

        .faq-icon {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          font-weight: bold;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .faq-item.active .faq-icon {
          background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
          transform: rotate(180deg);
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: all 0.4s ease;
          background: #ffffff;
        }

        .faq-item.active .faq-answer {
          max-height: 500px;
        }

        .faq-answer p {
          padding: 0 2rem 1.5rem;
          margin: 0;
          color: #6c757d;
          line-height: 1.6;
          font-size: 1rem;
          white-space: pre-line;
        }

        .faq-link {
          color: #007bff;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 2px 6px;
          border-radius: 4px;
          background: rgba(0, 123, 255, 0.1);
          border: 1px solid rgba(0, 123, 255, 0.2);
        }

        .faq-link:hover {
          color: #0056b3;
          text-decoration: none;
          background: rgba(0, 123, 255, 0.2);
          border-color: rgba(0, 123, 255, 0.3);
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
        }

        .clearfix {
          clear: both;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .faqasiatic {
            padding: 2rem 1rem;
            margin: 1rem 0;
          }

          .faq-question {
            padding: 1.25rem 1.5rem;
          }

          .faq-question h4 {
            font-size: 1rem;
            padding-right: 1.5rem;
          }

          .faq-answer p {
            padding: 0 1.5rem 1.25rem;
          }

          .faq-icon {
            width: 25px;
            height: 25px;
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .faqasiatic {
            padding: 1.5rem 1rem;
          }

          .faq-question {
            padding: 1rem 1.25rem;
          }

          .faq-question h4 {
            padding-right: 1.25rem;
          }

          .faq-answer p {
            padding: 0 1.25rem 1rem;
          }
        }

        /* Animation for smooth opening */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .faq-item.active .faq-answer {
          animation: fadeIn 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default FaqSection;